<template>
  <div>
    <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-select :options="listOfType" v-model="selectedType" :disabled="isEdit === true"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Link ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-select :options="listOfLinkId" v-model="selectedLinkId" :disabled="isEdit === true"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Parameter')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-input type="text" v-model="technicalParameters.param" :placeholder="$t('Fill in the field')"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-input type="text" v-model="technicalParameters.passwd"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Created on')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit" disabled>
      <b-form-input v-model="technicalParameters.reg_date"/>
    </b-form-group>
    <b-row>
      <b-col>
        <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveTechParam">Ok</b-button>
      </b-col>
      <b-col sm="1.5">
        <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideAddTechnicalParameters">{{ $t('Cancel') }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'
import moment from 'moment'

export default {
  props: {
    currentRow: null,
    selectedAccount: null,
    isEdit: null,
    currentRowTechnicalParameters: null
  },
  data () {
    return {
      listOfType: [],
      selectedType: '',
      listOfLinkId: [],
      selectedLinkId: '',
      technicalParameters: {
        'type_id': 0,
        'slink_id': 0,
        'param': '',
        'reg_date': moment().format('YYYY-MM-DDThh:mm'),
        'passwd': ''
      }
    }
  },
  methods: {
    async load () {
      if (this.isEdit) {
        this.technicalParameters.slink_id = this.currentRowTechnicalParameters.slink_id
        this.technicalParameters.type_id = this.currentRowTechnicalParameters.type_id
        this.technicalParameters.passwd = this.currentRowTechnicalParameters.passwd
        this.technicalParameters.param = this.currentRowTechnicalParameters.param
        this.technicalParameters.reg_date = moment(Number(this.currentRowTechnicalParameters.reg_date) * 1000).format('MM-DD-YYYY')
      }
      let listOfLinkId = await axiosInstance.get(this.$store.getters.API_SETTINGS_TECH_PARAMS_SLINKS + '?user_id=' + this.currentRow.user_id + '&account_id=' + this.selectedAccount).then(response => { return response.data })
      let listOfType = await axiosInstance.get(this.$store.getters.API_SETTINGS_TECH_PARAMS).then(response => { return response.data })
      for (let i in listOfLinkId) {
        listOfLinkId[i].value = listOfLinkId[i].slink_id
        listOfLinkId[i].text = listOfLinkId[i].service_name + ' (' + listOfLinkId[i].slink_id + ')'
      }
      this.listOfLinkId = listOfLinkId
      for (let i in this.listOfLinkId) {
        if (this.isEdit) {
          this.selectedLinkId = this.technicalParameters.slink_id
        } else {
          this.selectedLinkId = this.listOfLinkId[i].value
        }
        break
      }
      for (let i in listOfType) {
        listOfType[i].value = listOfType[i].id
        listOfType[i].text = listOfType[i].name + ' (' + listOfType[i].id + ')'
      }
      this.listOfType = listOfType
      for (let i in this.listOfType) {
        if (this.isEdit) {
          this.selectedType = this.technicalParameters.type_id
        } else {
          this.selectedType = this.listOfType[i].value
        }
        break
      }
    },
    saveTechParam () {
      if (!this.technicalParameters.param) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the field "Parameter"'), 'Error')
        return
      }
      this.technicalParameters.reg_date = Number(Date.parse(this.technicalParameters.reg_date)) / 1000
      if (this.isEdit) {
        this.technicalParameters.tech_param_id = this.currentRowTechnicalParameters.id
        axiosInstance.put(this.$store.getters.API_USERS_TECH_PARAMS, this.technicalParameters).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideAddTechnicalParameters')
            this.$emit('refreshTable')
          }
        })
      } else {
        this.technicalParameters.type_id = this.selectedType
        this.technicalParameters.slink_id = this.selectedLinkId
        axiosInstance.post(this.$store.getters.API_USERS_TECH_PARAMS, this.technicalParameters).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideAddTechnicalParameters')
            this.$emit('refreshTable')
          }
        })
      }
    },
    hideAddTechnicalParameters () {
      this.$emit('hideAddTechnicalParameters')
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/technicalParameters/formAdd.vue